export default ngModule => {

    ngModule.directive('chatWidget', (AonConfig) => {
        return {
            restrict: 'E',
            template: '<div class="chat-widget"><div id="zsiqwidget"></div></div>',
            link: (scope) => {
                const code = AonConfig.deployment.chat_widget_code;
                const src = AonConfig.deployment.chat_widget_src;
                scope.code = code;
                if (code) {
                    const configData = {
                        values: {},
                        ready: function () {
                        }
                    };
                    if (code) {
                        configData.widgetcode = code;
                    }
                    window.$zoho = window.$zoho || {};
                    window.$zoho.salesiq = $zoho.salesiq || configData;
                    const d = document;
                    const s = d.createElement("script");
                    s.type = "text/javascript";
                    s.id = "zsiqscript";
                    s.defer = true;
                    s.src = src || "https://salesiq.zoho.com/widget";
                    const t = d.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(s, t);
                }
            },
        };
    });

}



// WEBPACK FOOTER //
// ./src/directives/chat-widget.js